import { table } from './_table';

export const details = {
  namespaced: true,
  modules: {
    table
  }
};
